import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit'
import { ENDPOINT } from '~/apis/endPoint'

import request from '~/apis/request'
import { loadingStates } from '~/config/constant'
import { getInfoRestaurant, isInValidArray } from '~/utils'

export const requestPayment = createAsyncThunk(
  'payment/requestPayment',
  async (_arg, { rejectWithValue }) => {
    const { restaurantId, tableId } = getInfoRestaurant()
    try {
      const response = await request().post(
        `/restaurants/${restaurantId}/tables/${tableId}/requests`,
        {
          requests: [
            {
              kind: 'payment',
            },
          ],
        },
      )

      return response.data
    } catch (error) {
      if (!error.response) throw error
      const { status, data } = error.response

      return rejectWithValue({ status, data }) // Dùng để custom payload trả về trong rejected
    }
  },
)

export const fetchInfoPayment = createAsyncThunk(
  'payment/fetchInfoPayment',
  async (_arg, { rejectWithValue }) => {
    const { restaurantSlug, tableUid } = getInfoRestaurant()
    const URL = ENDPOINT.SERVING_SESSION_RECEIPT
    const params = {}

    if (restaurantSlug) params.restaurant_slug = restaurantSlug
    if (tableUid) params.table_uuid = tableUid
    try {
      const response = await request().get(URL, { params })

      return response.data
    } catch (error) {
      if (!error.response) throw error
      const { status, data } = error.response

      return rejectWithValue({ status, data }) // Dùng để custom payload trả về trong rejected
    }
  },
)

const initValue = {
  loading: loadingStates.pending,
  error: null,
  data: {},
  request: false,
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState: initValue,
  reducers: {
    resetStatePayment: () => initValue,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchInfoPayment.pending, (state) => {
        state.loading = loadingStates.pending
      })
      .addCase(fetchInfoPayment.fulfilled, (state, action) => {
        state.loading = loadingStates.success
        state.error = null

        state.data = convertDataPayment(action.payload)
      })
      .addCase(fetchInfoPayment.rejected, (state, action) => {
        state.loading = loadingStates.error
        state.error = action.payload
      })
      // request payment
      .addCase(requestPayment.pending, (state) => {
        state.loading = loadingStates.pending
      })
      .addCase(requestPayment.fulfilled, (state) => {
        state.loading = loadingStates.success
        state.request = true
        state.error = null
      })
      .addCase(requestPayment.rejected, (state, action) => {
        state.loading = loadingStates.error
        state.error = action.payload
      })
  },
})

export const { resetStatePayment } = paymentSlice.actions
export const selectInfoPayment = (state) => state.payment

// Bọc createSelector để tối ưu performance
export const infoPaymentSelector = createSelector(selectInfoPayment, (infoPayment) => infoPayment)

export default paymentSlice.reducer

const convertFoodOptions = (foodOptions = []) => {
  if (isInValidArray(foodOptions)) return []

  return foodOptions.map((foodOption) => {
    return {
      ...foodOption,
    }
  })
}

const convertFoodOptionTypes = (foodOptionTypes = []) => {
  if (isInValidArray(foodOptionTypes)) return []

  return foodOptionTypes.map((foodOptionType) => {
    const { food_options } = foodOptionType

    return {
      ...foodOptionType,
      foodOptions: convertFoodOptions(food_options),
    }
  })
}

const convertDataServingRequest = (servingRequests = []) => {
  if (isInValidArray(servingRequests)) return []

  return servingRequests.map((foodOptions) => {
    const { food_option_types } = foodOptions
    return {
      ...foodOptions,
      foodOptionTypes: convertFoodOptionTypes(food_option_types),
    }
  })
}

const convertDataPayment = (infoPayment) => {
  const {
    restaurant,
    table,
    serving_requests,
    sub_total,
    vat_fee,
    service_fee,
    total,
    total_quantity,
    extra_fee,
    discount_amount,
  } = infoPayment
  const { vat_rate, service_rate } = restaurant

  return {
    restaurant: {
      vatRate: vat_rate,
      serviceRate: service_rate,
    },
    table,
    servingRequests: convertDataServingRequest(serving_requests),
    subTotal: sub_total,
    vatFee: vat_fee,
    serviceFee: service_fee,
    extraFee: extra_fee,
    discountAmount: discount_amount,
    total,
    totalQuantityFoodItem: total_quantity,
  }
}
